// Nền dải thương hiệu của màn đăng nhập trên điện thoại: bản đồ tuyến giao hàng vẽ bằng hình học (không ảnh, không chuyển động) —
// các điểm hub nối bằng đường cong nhẹ như đường phố, một tuyến sáng từ điểm gửi tới ghim định vị. Màu theo currentColor
// (đặt trên nền --accent). Bản chép: apps/admin/src/components/auth/RouteMap.tsx (sửa thì sửa cả hai).

type Pt = readonly [number, number]

const NODES: Record<string, Pt> = {
  A: [70, 120], B: [250, 70], C: [450, 150], D: [690, 90],
  E: [140, 320], F: [380, 290], G: [600, 340], H: [760, 260],
  I: [60, 530], J: [290, 500], K: [520, 560], L: [730, 500],
  M: [170, 720], N: [420, 760], O: [650, 700],
  P: [90, 920], Q: [330, 950], R: [580, 900], S: [760, 960],
}
const EDGES = [
  'AB', 'BC', 'CD', 'AE', 'BF', 'CF', 'CG', 'DH', 'GH', 'EF', 'FG', 'EI', 'FJ', 'GK', 'HL', 'IJ', 'JK', 'KL',
  'IM', 'JM', 'JN', 'KN', 'KO', 'LO', 'MN', 'NO', 'MP', 'NQ', 'OR', 'OS', 'PQ', 'QR', 'RS',
]
/** Tuyến đang giao: điểm gửi (M) → … → ghim (D) */
const ROUTE = ['M', 'J', 'F', 'C', 'D']

/** Cạnh a→b thành đường cong bậc hai, lệch vuông góc ±10% độ dài (xen kẽ) cho giống đường phố. */
function curve(a: Pt, b: Pt, i: number, move = true): string {
  const [x1, y1] = a
  const [x2, y2] = b
  const dx = x2 - x1
  const dy = y2 - y1
  const k = (i % 2 ? 1 : -1) * 0.1
  const cx = (x1 + x2) / 2 - dy * k
  const cy = (y1 + y2) / 2 + dx * k
  return `${move ? `M${x1} ${y1} ` : ''}Q${cx.toFixed(1)} ${cy.toFixed(1)} ${x2} ${y2}`
}

const ROADS = EDGES.map(([a, b], i) => curve(NODES[a!]!, NODES[b!]!, i)).join(' ')
const ROUTE_D = ROUTE.slice(1).map((n, i) => curve(NODES[ROUTE[i]!]!, NODES[n]!, i + 1, i === 0)).join(' ')
const HUBS = Object.entries(NODES).filter(([k]) => !ROUTE.includes(k)).map(([, p]) => p)
const STOPS = ROUTE.slice(1, -1).map((k) => NODES[k]!)
const [OX, OY] = NODES[ROUTE[0]!]!
const [PX, PY] = NODES[ROUTE[ROUTE.length - 1]!]!

export function RouteMap({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 800 1000" preserveAspectRatio="xMidYMid slice" aria-hidden focusable="false">
      <path d={ROADS} fill="none" stroke="currentColor" strokeOpacity={0.2} strokeWidth={1.6} strokeLinecap="round" />
      {HUBS.map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r={3.6} fill="currentColor" fillOpacity={0.32} />)}
      <path d={ROUTE_D} fill="none" stroke="currentColor" strokeOpacity={0.9} strokeWidth={3.2} strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0.1 9" />
      <path d={ROUTE_D} fill="none" stroke="currentColor" strokeOpacity={0.35} strokeWidth={8} strokeLinecap="round" strokeLinejoin="round" />
      {STOPS.map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r={6} fill="currentColor" />)}
      {/* điểm gửi: ô vuông bo góc như thùng hàng */}
      <rect x={OX - 9} y={OY - 9} width={18} height={18} rx={4} fill="currentColor" />
      {/* ghim định vị: vòng mờ + chấm */}
      <circle cx={PX} cy={PY} r={22} fill="currentColor" fillOpacity={0.18} />
      <circle cx={PX} cy={PY} r={10} fill="currentColor" />
      <circle cx={PX} cy={PY} r={4} style={{ fill: 'rgb(var(--accent-soft))' }} />
    </svg>
  )
}
